import { persianLanguage } from "../../../constants/persianTerms";
import { useAuth } from "../../auth/auth-provider/auth-provider";
import { useServerTimeStore } from "../../stores/serverTimeStore";
import { useRealtimeHealth } from "../../realtime/health/useRealtimeHealth";
import { getServerStatusMessage } from "../../realtime/health/utils/getServerStatusMessage";
import "./AdminCommunicationWithServer.css";

export default function AdminCommunicationWithServer() {
    const auth = useAuth();
    const health = useRealtimeHealth();
    const time = useServerTimeStore(state => state.serverDateTime);

    if (!auth?.token || !auth?.user?.isAdmin) return null;

    return (
        <div className="admin-server-status" role="group"
             aria-label={persianLanguage.phrase.server.CONNECTION_WITH_SERVER}>
            <span className="admin-server-status__label">
                {persianLanguage.phrase.server.CONNECTION_WITH_SERVER}:
            </span>
            <span className="admin-server-status__value">
                {getServerStatusMessage(health, time)}
            </span>
        </div>
    );
}
